import loadable from '@loadable/component';

export const OrgDashboardEditInternshipPageContainerLoadable = loadable(
  () => import('./OrgDashboardEditInternshipPageContainer'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardEditInternshipPageContainer,
  },
);
